import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { EntityType } from 'src/graphql/generated/graphql.generated';
import { AppState } from 'src/store/appstate';
import {
  AccessibleItemProps,
  selectAccessibleItemEntitiesByPersonId,
} from 'src/store/generated/accessible-item-record.generated';
import { UserService } from '../tcs-identity/user.service';

@Injectable({ providedIn: 'root' })
export class AccessibleItemAuthorizationService {
  constructor(private _userService: UserService, private _store: Store<AppState>) {}

  public getAccessibleItems(type?: EntityType): Observable<AccessibleItemProps[]> {
    return this._userService.user$.pipe(
      switchMap((u) =>
        u == null
          ? of([])
          : this._store
              .select(selectAccessibleItemEntitiesByPersonId(u.id))
              .pipe(map((ais) => ais.toArray().filter((ai) => type == null || type === ai.type))),
      ),
    );
  }
}
